// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.subcategories', {
        url: '/subcategories?searchTerm',
        views: {
            'productList@product': {
                templateUrl: 'main/product/subcategories/subcategories.tpl.html',
                controller: 'SubCategoriesController as vm'
            }
        },
        resolve: {
            subCategories: subCategoriesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function subCategoriesResolver(SubCategoriesApiService, $stateParams) {
    return SubCategoriesApiService.getPage(1, 19, $stateParams.searchTerm);
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function SubCategoriesController($rootScope, $state, subCategories, $scope, SubCategoriesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.itemsPerPage = 19;
    vm.selectedSubCategoryId = 0;
    vm.subCategories = subCategories.results;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;
    vm.totalRows = subCategories.total;

    vm.searchTermChanged = searchTermChanged;
    vm.pageChanged = pageChanged;

    function loadSubCategories() {
        loadSpinnerService.start('mainSpinner');
        SubCategoriesApiService.getPage(vm.currentPage, vm.itemsPerPage, vm.searchTerm).then(function (response) {
            vm.subCategories = response.results;
            vm.totalRows = response.total;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

    function searchTermChanged() {
        vm.currentPage = 1;
        loadSubCategories();
    }

    function pageChanged() {
        loadSubCategories();
    }
}

angular
    .module('product.subcategories', ['subcategories.api','subcategories.subcategory'])
    .config(stateConfig)
    .controller('SubCategoriesController', SubCategoriesController);
